import Text from '@components/Text/Text'
import { useTypedSelector } from '../../store'
import './PageNotFoundContent.scss'
import { TextTag } from '@enums/textTag'
import { VelvetSDK } from 'sdk'

const PageNotFoundContent = () => {
  const V = VelvetSDK.Vocabulary.vocabulary
  const showPageNotFound = useTypedSelector((state) => state.pageNotFound.show)
  const pageNotFound = 'PAGE NOT FOUND!'

  return (
    <div className="page-not-found">
      {showPageNotFound && (
        <Text tag={TextTag.H1} className="page-not-found-text">
          {V?.pageNotFound ?? pageNotFound}
        </Text>
      )}
    </div>
  )
}

export default PageNotFoundContent
